export default __webpack_public_path__ + "static/media/Hauora-SemiBold.37af92bd.woff2";